import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StyledFilterCustomItem, StyledInput } from './StyledFilterItem';
import { mainTheme } from '@plecto/ui';

const StyledSelectAllBar = styled(StyledFilterCustomItem)`
	cursor: pointer;
	margin-bottom: 4px;
	border-bottom: 1px solid ${mainTheme.border.decorative};
`;

type SelectAllProps = {
	onToggle: () => void;
	count: number;
	allSelected: boolean;
	bottom?: boolean;
	disabled?: boolean;
}

export function SelectAll({ onToggle, count, allSelected, disabled = false }: SelectAllProps) {
	const { t } = useTranslation();

	const selectedAllLabel = allSelected ? t('{{count}} selected', { count }) : t('Select all ({{count}})', { count });

	return <StyledSelectAllBar onClick={onToggle}>
		<StyledInput checked={allSelected} onChange={onToggle} disabled={disabled} />
		<span>{selectedAllLabel}</span>
	</StyledSelectAllBar>;
}
